import styled from 'styled-components';

import { Box, Flex, Link } from '@electricjs/arc';

import { ItemImage } from '../ItemImage';

// establishes the containment context: this component's own rendered width (not the viewport's) is what the layout below reacts to
const ContainerContext = styled.div`
  container-type: inline-size;
  width: 100%;
`;

// below this width, there isn't enough room for the image beside the name, so it moves on top of it instead
const IMAGE_BREAK_CONTAINER_WIDTH = '22rem';

const ResponsiveContent = styled(Flex)`
  column-gap: 2rem;
  align-items: center;

  @container (max-width: ${IMAGE_BREAK_CONTAINER_WIDTH}) {
    flex-direction: column;
  }
`;

const ImageBox = styled(Box)`
  flex-basis: 12rem;

  @container (max-width: ${IMAGE_BREAK_CONTAINER_WIDTH}) {
    flex-basis: 10rem;
  }
`;

type ProductBasicInfoProps = {
  name: string;
  image?: string;
  onLinkClick: () => void;
};

export const ProductBasicInfo = ({
  name,
  image,
  onLinkClick,
}: ProductBasicInfoProps) => {
  return (
    <ContainerContext>
      <ResponsiveContent>
        <ImageBox>
          <ItemImage src={image} alt={name} size="cartSize" />
        </ImageBox>
        <Link
          id={`product-details-link-${name}`}
          flexGrow="1"
          href=""
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            e.stopPropagation();
            onLinkClick();
          }}>
          {name}
        </Link>
      </ResponsiveContent>
    </ContainerContext>
  );
};
